var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-unit-modal" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitContactData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "form-group row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(_vm._s(_vm.$t("islamic_finance.step_name"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
              _vm._v(" "),
              _c("div", {
                staticClass: "base-read-box base-read-box-field",
                domProps: { innerHTML: _vm._s(_vm.formData.name) },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("islamic_finance.form_title"))),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                _vm._v(" "),
                _c("base-input", {
                  ref: "title",
                  attrs: {
                    invalid: _vm.$v.formData.title.$error,
                    type: "text",
                    name: "title",
                    "tab-index": "3",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.title.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.title,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "title",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.title",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.title.$error
                  ? _c("div", [
                      !_vm.$v.formData.title.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$tc("validation.required")) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("label", { staticClass: "form-label" }, [
                  _vm._v(_vm._s(_vm.$t("islamic_finance.form_message"))),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                _vm._v(" "),
                _c("ckeditor", {
                  staticClass: "editor-instance",
                  attrs: {
                    invalid: _vm.$v.formData.message.$error,
                    config: _vm.editorConfig,
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.message.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.message,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "message", $$v)
                    },
                    expression: "formData.message",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.message.$error
                  ? _c("div", [
                      !_vm.$v.formData.message.required
                        ? _c("span", { staticClass: "text-danger" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$tc("validation.required")) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-footer" },
          [
            _c(
              "base-button",
              {
                staticClass: "mr-3",
                attrs: { outline: true, color: "theme", type: "button" },
                on: { click: _vm.closeContactModal },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("general.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "base-button",
              {
                attrs: {
                  loading: _vm.isLoading,
                  color: "theme",
                  icon: "save",
                  type: "submit",
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      !_vm.isEdit
                        ? _vm.$t("general.save")
                        : _vm.$t("general.update")
                    ) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }